<template>
	<div style="margin-bottom: -15px;" class="clearfix npagePage product">
		<div class="product_list">
			<div class="container">
				<div class="clearfix row">
					<div class="col-xs-12 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
						<a @click="clickEvent('/ac1')">
							<img src="/static/img/4gimg.jpg" />
						</a>
					</div>
					<div class="col-xs-6 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
						<a @click="clickEvent('/ac2')">
							<img src="/static/img/wifiimg.jpg" />
						</a>
					</div>
					<div class="col-xs-6 wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
						<a @click="clickEvent('/ac3')">
							<img src="/static/img/bluetoothImg.jpg" />
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="pde"></div>
	</div>
</template>


<script>
export default {
	data() {
		return {

		}
	},
	methods: {
		clickEvent(path) {
			this.$router.push(path)
		}
	}
}
</script>


<style scoped>
a {
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// aboutContent.vue?7a396e38